import { createAction } from 'redux-actions'

export const toggleAssortment = createAction('WORKSPACE_LIST/TOGGLE_ASSORTMENT')
export const resetSelectedAssortments = createAction(
  'WORKSPACE_LIST/RESET_SELECTED_ASSORTMENTS',
)
export const setSelectedWorkspaces = createAction(
  'WORKSPACE_LIST/BULK_TOGGLE_WORKSPACES',
)
export const toggleBrandNoteFilter = createAction(
  'WORKSPACE_LIST/TOGGLE_BRAND_NOTE_FILTER',
)
export const setArchivedFilter = createAction(
  'WORKSPACE_LIST/SET_ARCHIVED_FILTER',
)
export const setBrandNoteFilter = createAction(
  'WORKSPACE_LIST/SET_BRAND_NOTE_FILTER',
)
